import { Spin } from 'components';
import * as React from 'react';
import styled from 'styled-components';

const LoadingView: React.FC = () => (
    <StyledSpinContainer>
      <Spin size="large" center />
    </StyledSpinContainer>
  );

const StyledSpinContainer = styled.div`
  display: flex;
  min-height: inherit;
  align-items: center;
`;

export default LoadingView;
